import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/LAC_CMS/components/layouts/content-animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/LAC_CMS/components/layouts/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/LAC_CMS/components/layouts/overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/LAC_CMS/components/layouts/provider-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/LAC_CMS/components/layouts/scroll-to-top.tsx");
;
import(/* webpackMode: "eager" */ "/home/developer/LAC_CMS/node_modules/next/font/google/target.css?{\"path\":\"app/(form)/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\"}],\"variableName\":\"nunito\"}");
